import React, { useEffect, useState } from 'react';
import { IconButton, ButtonBase } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import CloseIcon from '@mui/icons-material/Close';
import FormGroup from '@mui/material/FormGroup';
import { UPDATE_USER_ROLE } from 'api';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useMutation } from '@apollo/client';
import styles from './EditRoleModal.module.scss';

const EditRoleModal = ({ open, handleClose, roles, userRole, userId, setUserRole }) => {
  const [checked, setChecked] = useState([]);
  const [error, setError] = useState(false);
  const [updateUserRole] = useMutation(UPDATE_USER_ROLE, {
    variables: { input: {} },
  });

  const handleCheck = (event) => {
    let updatedList = [...checked];
    if (event.target.checked) {
      updatedList = [...checked, event.target.value];
    } else {
      updatedList.splice(checked.indexOf(event.target.value), 1);
    }
    setChecked(updatedList);
  };

  useEffect(() => {
    if (open) {
      roles.map((item) => {
        if (userRole.includes(item.role)) {
          setChecked((current) => [...current, item.role]);
        }
        return item;
      });
    } else {
      setChecked([]);
    }
  }, [open]);

  const onSubmit = async () => {
    try {
      const userRoles = await updateUserRole({
        variables: { input: { user_id: userId, roles: checked } },
      });
      setUserRole(checked);
      handleClose();
    } catch (e) {
      setError(true);
    }
  };

  return (
    <Modal
      open={open}
      BackdropProps={{
        style: {
          backgroundColor: 'white',
          backdropFilter: 'blur(14px)',
          background: 'rgba(250, 250, 250, 0.8)',
        },
      }}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className={styles.editRoleModal}>
        <Box className={styles.modalTitle}>
          Do you want to change a user role?
          <IconButton
            aria-label="close"
            onClick={() => {
              handleClose();
              setError(false);
            }}
            sx={{
              position: 'absolute',
              right: 30,
              top: 20,
              color: (theme) => theme.palette.grey[900],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Box className={styles.modalContent}>
          <FormGroup>
            {roles.map((item) => (
              <FormControlLabel
                control={
                  <Checkbox
                    value={item.role}
                    onChange={handleCheck}
                    defaultChecked={userRole.includes(item.role)}
                  />
                }
                label={<Typography className={styles.roleName}>{item.role}</Typography>}
              />
            ))}
            {error && <Typography className={styles.errorText}>Please check any role</Typography>}
          </FormGroup>
        </Box>
        <Box className={styles.modalActions}>
          <ButtonBase
            className={styles.leftButton}
            onClick={() => {
              handleClose();
              setError(false);
            }}
          >
            CANCEL
          </ButtonBase>
          <ButtonBase className={styles.rightButton} onClick={onSubmit}>
            CONFIRM
          </ButtonBase>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditRoleModal;
